import modalStyles from '@/features/application/styles/modals.module.css';
import type { PaymentAdjustmentNoteSectionProps } from '../../types/modals';

export function PaymentAdjustmentNoteSection({
  tid,
  note,
  onNoteChange,
  requireNote,
  error,
}: PaymentAdjustmentNoteSectionProps) {
  return (
    <div>
      <label
        className="mb-2 block text-sm font-medium text-slate-600"
        data-testid={`${tid}-note-label`}
      >
        Note{requireNote && <span className="text-blue-500">*</span>}
      </label>
      <textarea
        value={note}
        onChange={(e) => onNoteChange(e.target.value)}
        data-testid={`${tid}-note-input`}
        aria-required={requireNote}
        className={`h-28 w-full resize-none rounded-xl border bg-white p-3 text-sm text-slate-900 outline-none transition focus:ring-2 ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : 'border-slate-200 focus:border-blue-500 focus:ring-blue-500/20'}`}
      />
      {error && (
        <p className={modalStyles.formFieldError} role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
